import React from 'react';
import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useTranslatedMessages } from '../../../hooks/useTranslatedMessages';

const IncompleteBusinessProfileLeaveDialog = ({ open, onClose, onLeave, onCompleteSetup }) => {
  const { businessProfiles } = useTranslatedMessages();
  const m = businessProfiles?.leave_incomplete_modal ?? {};

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: { borderRadius: 2 },
      }}
    >
      <DialogTitle
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          pb: 1,
        }}
      >
        <Typography variant="h6" component="span" fontWeight={700}>
          {m.title ?? 'Warning'}
        </Typography>
        <IconButton aria-label="close" onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ pt: 1 }}>
        <Alert severity="warning" sx={{ alignItems: 'flex-start' }}>
          {m.message ??
            'If you leave this profile without completing setup, you will not be able to invoice with this profile.'}
        </Alert>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2.5, pt: 1, gap: 1 }}>
        <Button data-testid="leave-incomplete-profile-go-back" variant="outlined" onClick={onLeave}>
          {m.go_back ?? 'Go back'}
        </Button>
        <Button
          data-testid="leave-incomplete-profile-complete"
          variant="contained"
          color="primary"
          onClick={onCompleteSetup}
        >
          {m.complete_setup ?? 'Complete it'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default IncompleteBusinessProfileLeaveDialog;
